import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get';
import { hashCode } from '../shared/helpers'

interface AppInput {
    label: string;
    path: string;
    name: string;
    placeholder: string;
    value?: any;
    onChange: any;
    errors: any;
    type?: string;
    required?: boolean;
    tip?: string;
    prefix?: string;
    datalist?: Array<any>;
    autocomplete?: string;
    minlength?: string;
    maxlength?: string;
    min?: string;
    max?: string;
}


export const AppInput: FunctionalComponent<AppInput> = ({ label, path, errors, name, placeholder, value, onChange, type = 'text', required, tip, prefix, datalist, autocomplete, minlength, maxlength, min, max }) => {

    const attributes : any = {};
    let hash;
    if (datalist) {
        const key = datalist.map(({Model}) => Model[0]).join('')
        hash = hashCode(key)
        attributes.list = `data-list-${name}-${hash}`
    }
    if (autocomplete) attributes.autocomplete = autocomplete;
    if (minlength) attributes.minlength = minlength;
    if (maxlength) attributes.maxlength = maxlength;
    if (min) attributes.min = min;
    if (max) attributes.max = max;

    return (
        <div class="uk-margin uk-width-1-1">
            <label class="uk-form-label" uk-tooltip={tip}>{label} <span class="uk-text-danger">{required && '*'}</span> <span class="uk-text-danger">{get(errors, [path, 'message'])}</span></label>
            <div class="uk-width-1-1 uk-form-controls uk-flex uk-flex-middle">
                <div hidden={!prefix} class="uk-margin-small-right">{prefix}</div>
                <div class='uk-flex-1'>
                    <input {...attributes} class={`uk-input ${get(errors, [path, 'message']) ? 'uk-form-danger' : ''}`} type={type} placeholder={placeholder} name={name} value={value} onChange={onChange} />
                    {
                        datalist && 
                        <datalist id={`data-list-${name}-${hash}`}>
                                {datalist.map(({ Model }) => <option value={Model} />)}
                        </datalist>
                    }
                </div>
            </div>
        </div>
    )
};


